import { render, staticRenderFns } from "./SideArrowsDisplay.vue?vue&type=template&id=0b760259&scoped=true&"
import script from "./SideArrowsDisplay.vue?vue&type=script&lang=js&"
export * from "./SideArrowsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SideArrowsDisplay.vue?vue&type=style&index=0&id=0b760259&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b760259",
  null
  
)

export default component.exports